import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

import Home from '@/modules/Languages/Home'
import One from '@/modules/Languages/One'

export default new Router({
  routes: [
    {
      path: '/',
      name: 'LanguagesHome',
      component: Home
    },
    {
      path: '/:lang',
      name: 'LanguagesOne',
      component: One
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/languages.js